<mat-card style="margin-bottom: 3px">
  <mat-dialog-actions
    style="margin-top: -30px; margin-bottom: -28px"
    align="center"
  >
    <button
      *ngIf="isMatDialogActionsOpen"
      mat-raised-button
      color="primary"
      (click)="onConfirmClick()"
      tabindex="1"
    >
      KAYDET
    </button>
    <button mat-button color="primary" mat-dialog-close tabindex="-1">
      KAPAT
    </button>
    <mat-checkbox
      *ngIf="isMatDialogActionsOpen"
      style="padding-top: 3px"
      [(ngModel)]="isServiceDefinition"
      [checked]="isServiceDefinition"
      (change)="onIsServiceDefinitionChange($event)"
    >
      Hizmet Tanımı
    </mat-checkbox>
    &nbsp;
    <mat-checkbox
      *ngIf="isMatDialogActionsOpen"
      style="padding-top: 3px"
      [(ngModel)]="isAgreementDefinition"
      [checked]="isAgreementDefinition"
      (change)="onIsAgreementDefinitionChange($event)"
    >
      Sözleşme Tanımı
    </mat-checkbox>
    &nbsp;
    <mat-checkbox
      *ngIf="isMatDialogActionsOpen"
      style="padding-top: 3px"
      [(ngModel)]="isContourDefinition"
      [checked]="isContourDefinition"
      (change)="onIsContourDefinitionChange($event)"
    >
      Kontör Tanımı
    </mat-checkbox>
    <span>&nbsp; &nbsp;&nbsp;&nbsp;</span>
    <ejs-dropdownlist
      *ngIf="isMatDialogActionsOpen && isAgreementDefinition"
      style="color: white; width: 40%; margin: 6px 0px 47px 4px"
      id="ddlelement"
      [dataSource]="agreementCodeData"
      [allowFiltering]="true"
      floatLabelType="Auto"
      placeholder="Partner Sözleşme Kodu"
      (change)="agreementCodeChange($event)"
      (filtering)="onFilteringAgreementCode($event)"
      [fields]="fields"
      [showClearButton]="true"
      popupHeight="200px"
      popupWidth="250px"
    >
    </ejs-dropdownlist>
  </mat-dialog-actions>
</mat-card>
<mat-dialog-content>
  <div>
    <div class="col-lg-9">
      <div *ngIf="isFileUploadCompleted">
        <ejs-uploader
          #defaultupload
          id="defaultfileupload"
          [dropArea]="dropElement"
          (selected)="onFileRemove($event)"
          (change)="onSuccess($event)"
        ></ejs-uploader>
      </div>
      <!-- (cellSave)="celsave($event)"
        (cellSaved)="celsaved($event)" -->
      <ejs-grid
        #grid
        id="grid"
        style="height: 250px"
        [dataSource]="CustomerDataList"
        (queryCellInfo)="customiseCell($event)"
        [resizeSettings]="resizeSettings"
        [allowResizing]="true"
        (dataBound)="dataBound($event)"
        enableHover="false"
        allowReordering="true"
        (keyPressed)="keyPressed($event)"
        [allowPaging]="true"
        [allowFiltering]="true"
        [pageSettings]="pageSettings"
        [editSettings]="editSettings"
        [toolbar]="toolbar"
      >
      </ejs-grid>
    </div>
  </div>
</mat-dialog-content>

<!-- hata aldıgında acılacak grid -->
<mat-card *ngIf="isErrorServer">
  <mat-card-title>Sonuçlar</mat-card-title>
  <mat-dialog-content>
    <div>
      <ejs-grid
        #grdresult
        id="grdresult"
        style="height: 200px"
        [dataSource]="ErrorDataList"
        (queryCellInfo)="customiseCell($event)"
        [resizeSettings]="resizeSettings"
        [allowResizing]="true"
        (dataBound)="dataBoundResult($event)"
        enableHover="false"
        [groupSettings]="groupOptions"
        [allowGrouping]="true"
        allowReordering="true"
        (keyPressed)="keyPressed($event)"
        [allowPaging]="true"
        [pageSettings]="pageSettings"
      >
        <e-columns>
          <e-column
            field="customerId"
            [showInColumnChooser]="false"
            width="14%"
            [customAttributes]="customAttributes"
            headerText="Firma VKN"
          ></e-column>
          <e-column
            field="statusDetails"
            [showInColumnChooser]="false"
            width="14%"
            [customAttributes]="customAttributes"
            headerText="Hata Detayı"
          ></e-column>
        </e-columns>
      </ejs-grid>
    </div>
  </mat-dialog-content>
  <!-- <mat-dialog-actions *ngIf="isErrorServer" align="center">
    <button mat-button mat-dialog-close tabindex="-1">KAPAT</button>
  </mat-dialog-actions> -->
</mat-card>
<div id="ej2Toast" #toast></div>
